import {Component} from '@angular/core';
import {CONTACT_ROUTE, PRIVACY_POLICY_ROUTE} from "src/app/app-routing.module";
import {Router} from "@angular/router";
import {environment} from "@environment";

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})
export class FooterComponent {
  public static backendVersion?:string|null;
  FooterComponent = FooterComponent;

  environment: any = environment;
  clientVersion:string = "1.0.11";
  constructor(private router: Router) {
  }

  goToPrivacyPolicy() {
    this.router.navigate([PRIVACY_POLICY_ROUTE]);
  }

  protected readonly CONTACT_ROUTE:string = CONTACT_ROUTE;
}
